module.exports = __webpack_public_path__ + "img/twitter-icon.e3b07ff9.svg";